module.exports = __webpack_public_path__ + "img/horizontal_4_2_9016.0eaaa013.png";